import { Box, Typography } from "@mui/material";
import ActivityItem from "./ActivityItem";
import theme from "../../configs/theme";

export default function ActivityTableDisplay({ 
  groupedActivities,
  showCheckbox,
  checkboxLabel,
  selectedActivities,
  setSelectedActivities,
}) {
  return (
    <Box
      sx={{
        backgroundColor: theme.tableColors.body,
        width: "60%",
        borderRadius: "8px",
        overflowY: "auto",
      }}
    >
      {Object.keys(groupedActivities).length === 0 ? (
        <Typography variant="body1" align="center" >
          Sin resultados
        </Typography>
      ) : (
        Object.entries(groupedActivities).map(([date, acts], index) => (
          <Box key={date} sx={{ mb: 2 }} borderTop={index !== 0 ? "2px solid white" : "none"}>
            <Typography variant="subtitle1" fontWeight="bold" my={1} ml={2}>
              {date}
            </Typography>
            {acts.map((activity) => (
              <ActivityItem 
                key={activity.id} 
                activity={activity}
                showCheckbox={showCheckbox}
                selected={selectedActivities.includes(activity.id)}
                onSelect={(id) => {
                  if (selectedActivities.includes(id)) {
                    setSelectedActivities(selectedActivities.filter((aid) => aid !== id));
                  } else {
                    if (showCheckbox && checkboxLabel === "Borrar") {
                      setSelectedActivities([...selectedActivities, id]);
                    } else {
                      setSelectedActivities([id]); // solo uno
                    }
                  
                  }
                }} 
              />
            ))}
          </Box>
        ))
      )}
    </Box>
  );
}
